export default __webpack_public_path__ + "static/media/eyeWhite.791352f9.svg";